import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendStoreList from '../RecommendStoreList';
import RecommendStoreListSearchBox from '../RecommendStoreListSearchBox';

const RecommendStoreListWrap = (props) => {
  const { recommendStoreList, setData, getList } = props;

  return (
    <div className="recommend-store-list-wrap">
      {/* 추천 브랜드 검색 박스*/}
      <RecommendStoreListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendStoreList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendStoreList.searchData}
        getList={getList}
      />

      {/* 추천 브랜드 리스트*/}
      <RecommendStoreList
        recommendStoreList={recommendStoreList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendStoreList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendStoreListWrap;
